/**
 * RGAA 10.8 — Carrousels « une diapositive à la fois » (effet fondu / slidesPerView: 1).
 *
 * Les diapositives non actives sont masquées visuellement (opacity 0) mais restent
 * dans l'arbre d'accessibilité et focusables au clavier. On ne conserve que la
 * diapositive active ; les autres reçoivent l'attribut `inert` (ignorées des
 * technologies d'assistance ET non focusables). `inert` n'affecte pas la mise en
 * page : aucun impact visuel.
 */
export function hideInactiveSlides(swiper) {
	swiper.slides.forEach((slide, index) => {
		slide.toggleAttribute("inert", index !== swiper.activeIndex);
	});
}

/**
 * Fragment d'options Swiper à fusionner dans la config d'un carrousel mono-slide :
 * active le module a11y (libellés FR) et rebranche le masquage à l'init et à
 * chaque changement de diapositive.
 */
export const singleSlideA11y = {
	a11y: {
		enabled: true,
		prevSlideMessage: "Diapositive précédente",
		nextSlideMessage: "Diapositive suivante",
		slideLabelMessage: "Diapositive {{index}} sur {{slidesLength}}",
	},
	on: {
		afterInit: hideInactiveSlides,
		slideChange: hideInactiveSlides,
	},
};

/**
 * RGAA 10.8 — Carrousels à défilement (slidesPerView: "auto") DISPOSANT DE FLÈCHES.
 *
 * Les diapositives entièrement hors du cadre visible reçoivent `inert` : ignorées
 * des technologies d'assistance et non focusables. Elles restent atteignables au
 * clavier via les flèches précédent/suivant, qui les ramènent dans le cadre (elles
 * perdent alors `inert`). À n'utiliser QUE sur un carrousel muni d'une navigation,
 * sinon le contenu masqué devient inatteignable au clavier.
 *
 * Repose sur la classe `swiper-slide-visible` (nécessite `watchSlidesProgress`),
 * ajoutée par Swiper aux diapositives au moins partiellement visibles.
 */
export function hideNonVisibleSlides(swiper) {
	swiper.slides.forEach((slide) => {
		slide.toggleAttribute("inert", !slide.classList.contains("swiper-slide-visible"));
	});
}

export const scrollSlidesA11y = {
	watchSlidesProgress: true,
	a11y: {
		enabled: true,
		prevSlideMessage: "Élément précédent",
		nextSlideMessage: "Élément suivant",
	},
	on: {
		afterInit: hideNonVisibleSlides,
		setTranslate: hideNonVisibleSlides,
		transitionEnd: hideNonVisibleSlides,
		resize: hideNonVisibleSlides,
	},
};
